import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import 'react-quill/dist/quill.bubble.css';
import './RichTextEditor.css';

// Accept className and forward any extra props to underlying ReactQuill
const RichTextEditor = ({ value, onChange, placeholder = 'Enter description...', readOnly = false, className = '', ...props }) => {
  const modules = {
    toolbar: [
      [{ 'header': [1, 2, 3, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'color': [] }, { 'background': [] }],
      ['link'],
      ['clean']
    ],
  };

  const formats = [
    'header',
    'bold', 'italic', 'underline', 'strike',
    'list', 'bullet',
    'color', 'background',
    'link'
  ];

  return (
    <ReactQuill
      // Force a remount when switching between readOnly/view and edit modes so Quill's
      // internal state resets and picks up the new value/theme correctly.
      key={readOnly ? 'quill-view' : 'quill-edit'}
      theme={readOnly ? 'bubble' : 'snow'}
      // Ensure value is always a string to avoid uncontrolled behavior
      value={value ?? ''}
      onChange={onChange}
      modules={modules}
      formats={formats}
      placeholder={readOnly ? '' : placeholder}
      readOnly={readOnly}
      className={("bg-white rounded-md " + (readOnly ? "read-only-editor" : "") + " " + className).trim()}
      style={readOnly ? {} : { minHeight: 150 }}
      data-editor-mode={readOnly ? 'view' : 'edit'}
      {...props}
    />
  );
};

export default RichTextEditor;
